var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"title":_vm.$t('pages.globalSnackbar.title')}}),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.showSnackbar}},[_vm._v(" "+_vm._s(_vm.$t('pages.globalSnackbar.showSnackbar'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }